__turbopack_context__.v({
  "article": "CBlog-module__hVkBrq__article",
  "articleAuthorAvatar": "CBlog-module__hVkBrq__articleAuthorAvatar",
  "articleAuthorName": "CBlog-module__hVkBrq__articleAuthorName",
  "articleAuthorRow": "CBlog-module__hVkBrq__articleAuthorRow",
  "articleBackLink": "CBlog-module__hVkBrq__articleBackLink",
  "articleCategoryPill": "CBlog-module__hVkBrq__articleCategoryPill",
  "articleHeader": "CBlog-module__hVkBrq__articleHeader",
  "articleHeaderBg": "CBlog-module__hVkBrq__articleHeaderBg",
  "articleLead": "CBlog-module__hVkBrq__articleLead",
  "articleMainImage": "CBlog-module__hVkBrq__articleMainImage",
  "articleTitle": "CBlog-module__hVkBrq__articleTitle",
  "articleTopDate": "CBlog-module__hVkBrq__articleTopDate",
  "articleTopMeta": "CBlog-module__hVkBrq__articleTopMeta",
  "body": "CBlog-module__hVkBrq__body",
  "card": "CBlog-module__hVkBrq__card",
  "cardLink": "CBlog-module__hVkBrq__cardLink",
  "cardMeta": "CBlog-module__hVkBrq__cardMeta",
  "empty": "CBlog-module__hVkBrq__empty",
  "list": "CBlog-module__hVkBrq__list",
  "listDescription": "CBlog-module__hVkBrq__listDescription",
  "listEyebrow": "CBlog-module__hVkBrq__listEyebrow",
  "listHeaderBg": "CBlog-module__hVkBrq__listHeaderBg",
  "listHeaderInner": "CBlog-module__hVkBrq__listHeaderInner",
  "listHeading": "CBlog-module__hVkBrq__listHeading",
  "more": "CBlog-module__hVkBrq__more",
  "pagination": "CBlog-module__hVkBrq__pagination",
  "paginationHint": "CBlog-module__hVkBrq__paginationHint",
  "paginationInfo": "CBlog-module__hVkBrq__paginationInfo",
  "root": "CBlog-module__hVkBrq__root",
  "short": "CBlog-module__hVkBrq__short",
  "thumb": "CBlog-module__hVkBrq__thumb",
  "thumbPlaceholder": "CBlog-module__hVkBrq__thumbPlaceholder",
  "thumbWrap": "CBlog-module__hVkBrq__thumbWrap",
  "title": "CBlog-module__hVkBrq__title",
});
